import { render, staticRenderFns } from "./symptom.vue?vue&type=template&id=33de2baa&scoped=true&"
import script from "./symptom.vue?vue&type=script&lang=ts&"
export * from "./symptom.vue?vue&type=script&lang=ts&"
import style0 from "./symptom.vue?vue&type=style&index=0&id=33de2baa&prod&lang=scss&scoped=true&"
import style1 from "./symptom.vue?vue&type=style&index=1&id=33de2baa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33de2baa",
  null
  
)

export default component.exports